module.exports = __webpack_public_path__ + "static/media/header.8a58332f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/psy/header.png
// module id = 730
// module chunks = 1